import { render } from "./YearMonthSelector.vue?vue&type=template&id=ea844e0e&scoped=true&bindings={\"locale\":\"props\",\"dark\":\"props\",\"color\":\"props\",\"mode\":\"props\",\"month\":\"props\",\"months\":\"data\",\"years\":\"data\",\"currentMonth\":\"options\",\"currentYear\":\"options\",\"isMonthMode\":\"options\",\"getMonths\":\"options\",\"getYears\":\"options\",\"selectMonth\":\"options\",\"selectYear\":\"options\"}"
import script from "./YearMonthSelector.vue?vue&type=script&lang=js"
export * from "./YearMonthSelector.vue?vue&type=script&lang=js"

import "./YearMonthSelector.vue?vue&type=style&index=0&id=ea844e0e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ea844e0e"

export default script